<template>
  <div class="app">
    <RmHeader />
    <GlobalComponents />
    <div
      v-show="isShowCategoriesMenu"
      class="is-shadow"
    />
    <div class="relative">
      <NuxtPage />
    </div>
    <MobileNav class="md:hidden" />
  </div>
</template>

<script>
import RmHeader from '~/components/header/index.vue'
import GlobalComponents from '~/components/layout/global_components.vue'
import MobileNav from '~/components/layout/mobile_nav.vue'

export default {
  name: 'LayoutCatalog',
  components: {
    RmHeader,
    MobileNav,
    GlobalComponents,
  },
  setup () {
    return {
      isShowCategoriesMenu: useGlobal().isShowCategoriesMenu,
    }
  },
}
</script>
